import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

import WindowOriginService from './WindowOriginService';

type IssueType = {
  name: string;
};

export default {
  async getIssueTypes(projectId: number): Promise<Array<IssueType>> {
    const APIConstants = StorageOfUniqueServices.get('APIConstants');
    const url =
      WindowOriginService.origin +
      APIConstants.URL_ISSUE_TYPES +
      '/' +
      projectId;

    return (await axios.get(url)).data;
  },
};
